import { tag } from '@blotoutio/edgetag-sdk-js';
import { CartInterface, CartLineItemInterface } from '@qlevr/shared/interfaces';
import { getShopifyProductId, replaceProductSlugInUrl } from '@qlevr/shared/utilities';

export function blotoutRemoveFromCart(
  cartData: CartInterface | undefined,
  item: CartLineItemInterface | undefined,
): void {
  const contents = item
    ? [
        {
          id: getShopifyProductId(item.productId ?? '') || '',
          quantity: item.quantity ?? 1,
          item_price: parseFloat(item.price?.amount?.toString() ?? '0.0'),
          title: item.title ?? '',
          category: item.productType ?? '',
          image: item.featuredImage?.lg.url ?? item.featuredImage?.url ?? '',
          url: replaceProductSlugInUrl(window.location.href, item.slug ?? ''),
          brand: item.vendor ?? '',
          variantId: getShopifyProductId(item.variantId ?? '') || '',
          sku: item.sku ?? '',
        },
      ]
    : [];

  tag('RemoveFromCart', {
    currency: 'EUR',
    value: parseFloat(cartData?.cost?.totalAmount?.amount?.toString() ?? '0.0'),
    contents: contents,
    checkoutUrl: `/checkout`,
  });
}
